import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$default1kkisaow5bg5n as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from '../encoding/Decoding.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedValueDecoderClass;
function NamedValueDecoder() {
  if (NamedValueDecoderClass === VOID) {
    class $ extends TaggedDecoder() {
      h25(_this__u8e3s4, index) {
        return this.j25(this.i25(_this__u8e3s4, index));
      }
      j25(nestedName) {
        var tmp0_elvis_lhs = this.m25();
        return this.n25(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
      }
      i25(descriptor, index) {
        return descriptor.h1p(index);
      }
      n25(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
      o25() {
        return this.k25_1.n1() ? '$' : joinToString(this.k25_1, '.', '$.');
      }
    }
    initMetadataForClass($, 'NamedValueDecoder');
    NamedValueDecoderClass = $;
  }
  return NamedValueDecoderClass;
}
function tagBlock($this, tag, block) {
  $this.c26(tag);
  var r = block();
  if (!$this.l25_1) {
    $this.d26();
  }
  $this.l25_1 = false;
  return r;
}
var TaggedDecoderClass;
function TaggedDecoder() {
  if (TaggedDecoderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.k25_1 = ArrayList().p2();
        this.l25_1 = false;
      }
      n1r() {
        return EmptySerializersModule();
      }
      p25(tag) {
        throw SerializationException().c1o(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      q25(tag) {
        return true;
      }
      r25(tag) {
        var tmp = this.p25(tag);
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      s25(tag) {
        var tmp = this.p25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      t25(tag) {
        var tmp = this.p25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      u25(tag) {
        var tmp = this.p25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      v25(tag) {
        var tmp = this.p25(tag);
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      w25(tag) {
        var tmp = this.p25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      x25(tag) {
        var tmp = this.p25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      y25(tag) {
        var tmp = this.p25(tag);
        return tmp instanceof Char() ? tmp.e4_1 : THROW_CCE();
      }
      z25(tag) {
        var tmp = this.p25(tag);
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      a26(tag, enumDescriptor) {
        var tmp = this.p25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      b26(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        this.c26(tag);
        return this;
      }
      w1q(deserializer, previousValue) {
        return this.x1q(deserializer);
      }
      v1q(descriptor) {
        return this.b26(this.d26(), descriptor);
      }
      j1q() {
        var tmp0_elvis_lhs = this.m25();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var currentTag = tmp;
        return this.q25(currentTag);
      }
      k1q() {
        return null;
      }
      l1q() {
        return this.r25(this.d26());
      }
      m1q() {
        return this.s25(this.d26());
      }
      n1q() {
        return this.t25(this.d26());
      }
      o1q() {
        return this.u25(this.d26());
      }
      p1q() {
        return this.v25(this.d26());
      }
      q1q() {
        return this.w25(this.d26());
      }
      r1q() {
        return this.x25(this.d26());
      }
      s1q() {
        return this.y25(this.d26());
      }
      t1q() {
        return this.z25(this.d26());
      }
      u1q(enumDescriptor) {
        return this.a26(this.d26(), enumDescriptor);
      }
      y1q(descriptor) {
        return this;
      }
      z1q(descriptor) {
      }
      a1r(descriptor, index) {
        return this.r25(this.h25(descriptor, index));
      }
      b1r(descriptor, index) {
        return this.s25(this.h25(descriptor, index));
      }
      c1r(descriptor, index) {
        return this.t25(this.h25(descriptor, index));
      }
      d1r(descriptor, index) {
        return this.u25(this.h25(descriptor, index));
      }
      e1r(descriptor, index) {
        return this.v25(this.h25(descriptor, index));
      }
      f1r(descriptor, index) {
        return this.w25(this.h25(descriptor, index));
      }
      g1r(descriptor, index) {
        return this.x25(this.h25(descriptor, index));
      }
      h1r(descriptor, index) {
        return this.y25(this.h25(descriptor, index));
      }
      i1r(descriptor, index) {
        return this.z25(this.h25(descriptor, index));
      }
      j1r(descriptor, index) {
        return this.b26(this.h25(descriptor, index), descriptor.k1p(index));
      }
      k1r(descriptor, index, deserializer, previousValue) {
        var tmp = this.h25(descriptor, index);
        return tagBlock(this, tmp, () => this.w1q(deserializer, previousValue));
      }
      m1r(descriptor, index, deserializer, previousValue) {
        var tmp = this.h25(descriptor, index);
        return tagBlock(this, tmp, () => {
          // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
          var isNullabilitySupported = deserializer.h1m().w1o();
          var tmp;
          if (isNullabilitySupported || this.j1q()) {
            tmp = this.w1q(deserializer, previousValue);
          } else {
            tmp = this.k1q();
          }
          return tmp;
        });
      }
      m25() {
        return lastOrNull(this.k25_1);
      }
      c26(name) {
        this.k25_1.i2(name);
      }
      d26() {
        var r = this.k25_1.c5(get_lastIndex(this.k25_1));
        this.l25_1 = true;
        return r;
      }
    }
    protoOf($).l1r = decodeSerializableElement$default;
    protoOf($).x1q = decodeSerializableValue;
    protoOf($).o1r = decodeSequentially;
    protoOf($).q1r = decodeCollectionSize;
    initMetadataForClass($, 'TaggedDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    TaggedDecoderClass = $;
  }
  return TaggedDecoderClass;
}
//region block: exports
export {
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
};
//endregion

//# sourceMappingURL=Tagged.mjs.map
